import { createRouter, createWebHistory } from 'vue-router';

import HomeMain from './components/home/HomeMain.vue'
import ComingSoon from './components/shared/ComingSoon.vue'
import PathNotFound from './components/shared/PathNotFound.vue'
import Covid19 from './components/covid19/Covid19Main.vue'
import Telemedicine from './components/telemedicine/TelemedicineMain.vue'
import AboutUs from './components/aboutus/AboutUsMain.vue'
import Corporate from './components/corporate/CorporateMain.vue'
import Insurer from './components/insurer/InsurerMain.vue'
import Patients from './components/patients/PatientsMain.vue'
import Services from './components/services/ServicesMain.vue'
import OurCheckupPackages from './components/services/subpages/ourcheckuppackages/OurCheckupPackagesMain.vue'
import BookYourAppointment from './components/bookYourAppointment/BookYourAppointmentMain.vue'
import Promotion from './components/promotion/Promotion.vue'
import PromotionAgent from './components/promotion/PromotionAgent.vue'
import PromotionLYA from './components/promotion/PromotionLYA.vue'
import WorkWithUs from './components/workWithUs/WorkWithUsMain.vue'
import FactSheet from './components/factSheet/FactSheetMain.vue'
import FactSheetAlcoholConsumption from './components/factSheet/subpages/AlcoholConsumption.vue'
import FactSheetBreastCancer from './components/factSheet/subpages/BreastCancer.vue'
import FactSheetHeartDiseases from './components/factSheet/subpages/HeartDiseases.vue'
import FactSheetCervicalCancer from './components/factSheet/subpages/CervicalCancer.vue'
import FactSheetCholesteral from './components/factSheet/subpages/Cholesteral.vue'
import FactSheetColorectalCancer from './components/factSheet/subpages/ColorectalCancer.vue'
import FactSheetFattyLiver from './components/factSheet/subpages/FattyLiver.vue'
import FactSheetGout from './components/factSheet/subpages/Gout.vue'
import FactSheetHazardsOfSmoking from './components/factSheet/subpages/HazardsOfSmoking.vue'
import FactSheetHepatitisA from './components/factSheet/subpages/HepatitisA.vue'
import FactSheetHepatitisB from './components/factSheet/subpages/HepatitisB.vue'
import FactSheetHypertension from './components/factSheet/subpages/Hypertension.vue'
import FactSheetObesity from './components/factSheet/subpages/Obesity.vue'
import BivalentVaccine from './components/bivalentVaccine/BivalentVaccineMain.vue'
import FactSheetDiabetesMellitus from './components/factSheet/subpages/DiabetesMellitus.vue'
import FactSheetOsteoporosis from './components/factSheet/subpages/Osteoporosis.vue'
import FactSheetProstateCancer from './components/factSheet/subpages/ProstateCancer.vue'
import NaviVaccinationMain from './components/naviVaccination/NaviVaccinationMain.vue';
import TPA from './components/tpa/TPAMain.vue'
import NursingMain from './components/nursing/NursingMain.vue'
import Login from './components/login/Login.vue'

const routes = [
  { path: '/', redirect: { name: 'home' } },
  { path: '/home', name: 'home', component: HomeMain, meta: { title: 'Home' } },
  { path: '/comingsoon', name: 'comingsoon', component: ComingSoon, meta: { title: 'Coming Soon' } },
  { path: '/covid19', name: 'covid19', component: Covid19, meta: { title: 'Covid19' } },
  { path: '/telemedicine', name: 'telemedicine', component: Telemedicine, meta: { title: 'Telemedicine' } },
  { path: '/corptelemedicine', name: 'corptelemedicine', component: Telemedicine, meta: { title: 'Telemedicine', color: '#8F8248' } },
  { path: '/insutelemedicine', name: 'insutelemedicine', component: Telemedicine, meta: { title: 'Telemedicine', color: '#82488F' } },
  { path: '/patitelemedicine', name: 'patitelemedicine', component: Telemedicine, meta: { title: 'Telemedicine', color: '#488F82' } },
  { path: '/aboutus', name: 'aboutus', component: AboutUs, meta: { title: 'About Us' } },
  { path: '/aboutcorporate', name: 'aboutcorporate', component: Corporate, meta: { title: 'Corporate' } },
  { path: '/aboutinsurer', name: 'aboutinsurer', component: Insurer, meta: { title: 'Insurer' } },
  { path: '/aboutpatients', name: 'aboutpatients', component: Patients, meta: { title: 'Patients' } },
  { path: '/aboutservices', name: 'aboutservices', component: Services, meta: { title: 'Services' } },
  // { path: '/checkupservices', name: 'ourcheckuppackages', component: OurCheckupPackages, meta: { title: 'OurCheckupPackages' } },
  { path: '/insucheckupservices', name: 'insucheckupservices', component: OurCheckupPackages, meta: { title: 'OurCheckupPackages', color: '#82488F' } },
  { path: '/paticheckupservices', name: 'paticheckupservices', component: OurCheckupPackages, meta: { title: 'OurCheckupPackages', color: '#488F82' } },
  { path: '/servcheckupservices', name: 'servcheckupservices', component: OurCheckupPackages, meta: { title: 'OurCheckupPackages', color: '#603813' } },
  { path: '/bookyourappointment', name: 'bookyourappointment', component: BookYourAppointment, meta: { title: 'BookYourAppointment' } },
  { path: '/workwithus', name: 'workwithus', component: WorkWithUs, meta: { title: 'WorkWithUs' } },
  { path: '/factsheet', name: 'factsheet', component: FactSheet, meta: { title: 'FactSheet' } },
  { path: '/factsheet/alcoholConsumption', name: 'factSheetAlcoholConsumption', component: FactSheetAlcoholConsumption, meta: { title: 'FactSheetAlcoholConsumption' } },
  { path: '/factsheet/breastCancer', name: 'factSheetBreastCancer', component: FactSheetBreastCancer, meta: { title: 'FactSheetBreastCancer' } },
  { path: '/factsheet/heartDiseases', name: 'factSheetCornonaryArteryDisease', component: FactSheetHeartDiseases, meta: { title: 'FactSheetHeartDiseases' } },
  { path: '/factsheet/cervicalCancer', name: 'factSheetCervicalCancer', component: FactSheetCervicalCancer, meta: { title: 'FactSheetCervicalCancer' } },
  { path: '/factsheet/cholesteral', name: 'factSheetCholesteral', component: FactSheetCholesteral, meta: { title: 'FactSheetCholesteral' } },
  { path: '/factsheet/colorectalCancer', name: 'factSheetColorectalCancer', component: FactSheetColorectalCancer, meta: { title: 'FactSheetColorectalCancer' } },
  { path: '/factsheet/fattyLiver', name: 'factSheetFattyLiver', component: FactSheetFattyLiver, meta: { title: 'FactSheetFattyLiver' } },
  { path: '/factsheet/gout', name: 'factSheetGout', component: FactSheetGout, meta: { title: 'FactSheetGout' } },
  { path: '/factsheet/hazardsOfSmoking', name: 'factSheetHazardsOfSmoking', component: FactSheetHazardsOfSmoking, meta: { title: 'FactSheetHazardsOfSmoking' } },
  { path: '/factsheet/hepatitisA', name: 'factSheetHepatitisA', component: FactSheetHepatitisA, meta: { title: 'FactSheetHepatitisA' } },
  { path: '/factsheet/factSheetHepatitisB', name: 'factSheetHepatitisB', component: FactSheetHepatitisB, meta: { title: 'FactSheetHepatitisB' } },
  { path: '/factsheet/factSheetHypertension', name: 'factSheetHypertension', component: FactSheetHypertension, meta: { title: 'FactSheetHypertension' } },
  { path: '/factsheet/factSheetDiabetesMellitus', name: 'factSheetDiabetesMellitus', component: FactSheetDiabetesMellitus, meta: { title: 'FactSheetDiabetesMellitus' } },
  { path: '/factsheet/factSheetObesity', name: 'factSheetObesity', component: FactSheetObesity, meta: { title: 'FactSheetObesity' } },
  { path: '/factsheet/Osteoporosis', name: 'factSheetOsteoporosis', component: FactSheetOsteoporosis, meta: { title: 'FactSheetOsteoporosis' } },
  { path: '/factsheet/ProstateCancer', name: 'factSheetProstateCancer', component: FactSheetProstateCancer, meta: { title: 'FactSheetProstateCancer' } },
  { path: '/bivalentvaccine', name: 'bivalentvaccine', component: BivalentVaccine, meta: { title: 'BivalentVaccine' } },
  { path: '/promotion', name: 'promotion', component: Promotion, meta: { title: 'Promotion' } },
  // { path: '/promotion/agent', name: 'promotionagent', component: PromotionAgent, meta: { title: 'PromotionAgent' } },
  // { path: '/promotion/LYA', name: 'promotionLYA', component: PromotionLYA, meta: { title: 'PromotionLYA' } },
  // { path: '/vaccination', name: 'vaccination', component: NaviVaccinationMain },
  { path: '/corpvaccination', name: 'corpvaccination', component: NaviVaccinationMain, meta: { title: 'Vaccination', color: '#8F8248' } },
  { path: '/insuvaccination', name: 'insuvaccination', component: NaviVaccinationMain, meta: { title: 'Vaccination', color: '#82488F' } },
  { path: '/pativaccination', name: 'pativaccination', component: NaviVaccinationMain, meta: { title: 'Vaccination', color: '#488F82' } },
  // { path: '/nursing', name: 'nursingservices', component: NursingMain, meta: { title: 'NursingServices' } },
  { path: '/insunursing', name: 'insunursingservices', component: NursingMain, meta: { title: 'NursingServices', color: '#82488F' } },
  { path: '/patinursing', name: 'patinursingservices', component: NursingMain, meta: { title: 'NursingServices', color: '#488F82' } },
  { path: '/tpa', name: 'tpa', component: TPA, meta: { title: 'ThirdPartyAdministrationServices'} },
  { path: '/login', name: 'login', component: Login },
  // { path: '/comingsoon', name: 'emergencyassistance', component: ComingSoon, meta: { title: 'Coming Soon' } },
  // { path: '/comingsoon', name: 'ourvalues', component: ComingSoon, meta: { title: 'Coming Soon' } },
  // { path: '/comingsoon', name: 'ourteam', component: ComingSoon, meta: { title: 'Coming Soon' } },
  // { path: '/comingsoon', name: 'ourservices', component: ComingSoon, meta: { title: 'Coming Soon' } },
  // { path: '/comingsoon', name: 'ourfacilities', component: ComingSoon, meta: { title: 'Coming Soon' } },
  // { path: '/comingsoon', name: 'investorrelations', component: ComingSoon, meta: { title: 'Coming Soon' } },
  { path: "/:pathMatch(.*)*", name: 'pathNotFound', component: PathNotFound }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
          setTimeout(() => {
            let offset;
            switch (to.hash) {
              // corporate
              case '#aboutCor':
                offset = 0;
                break;
              case '#healthSol':
                offset = document.documentElement.scrollHeight * 0.11;
                break;
              case '#preventWel':
                offset = document.documentElement.scrollHeight * 0.27;
                break;
              case '#healthAna':
                offset = document.documentElement.scrollHeight * 0.34;
                break;
              case '#employHea':
                offset = document.documentElement.scrollHeight * 0.42;
                break;
              case '#medicalAdv':
                offset = document.documentElement.scrollHeight * 0.49;
                break;

              // insurer
              case '#aboutIns':
                offset = 0;
                break;
              case '#networkDoc':
                offset = document.documentElement.scrollHeight * 0.115;
                break;
              case '#costCon':
                offset = document.documentElement.scrollHeight * 0.30;
                break;
              case '#callCen':
                offset = document.documentElement.scrollHeight * 0.42;
                break;

              // patients
              case '#aboutPat':
                offset = 0;
                break;
              case '#patientExp':
                offset = document.documentElement.scrollHeight * 0.11;
                break;
              case '#healthOpt':
                offset = document.documentElement.scrollHeight * 0.26;
                break;
              case '#diseaseMan':
                offset = document.documentElement.scrollHeight * 0.34;
                break;
              case '#doctorRef':
                offset = document.documentElement.scrollHeight * 0.415;
                break;
              case '#homeCar':
                offset = document.documentElement.scrollHeight * 0.49;
                break;

              // services
              case '#aboutSer':
                offset = 0;
                break;
              case '#corporatePac':
                offset = document.documentElement.scrollHeight * 0.085;
                break;
              case '#advisory':
                offset = document.documentElement.scrollHeight * 0.17;
                break;
              case '#checkupSer':
                offset = document.documentElement.scrollHeight * 0.23;
                break;
              case '#telemedicine':
                offset = document.documentElement.scrollHeight * 0.29;
                break;
              case '#tpa':
                offset = document.documentElement.scrollHeight * 0.35;
                break;
              case '#outpatientSer':
                offset = document.documentElement.scrollHeight * 0.415;
                break;
              case '#vaccinations':
                offset = document.documentElement.scrollHeight * 0.475;
                break;
              case '#emergencyAss':
                offset = document.documentElement.scrollHeight * 0.535;
                break;
              case '#prodPro':
                offset = document.documentElement.scrollHeight * 0.595;
                break;

              // work with us
              case '#joinOur':
                offset = document.documentElement.scrollHeight * 0.13;
                break;
              case '#whyThe':
                offset = document.documentElement.scrollHeight * 0.32;
                break;

              case '#appointment':
                offset = document.documentElement.scrollHeight * 0;
                break;

              case '#login':
                offset = document.documentElement.scrollHeight * 0;
                break;

              default:
                offset = document.documentElement.scrollHeight * 0;
                break;
            }
            window.scrollTo({ top: offset, behavior: 'smooth' });
          }, 500);
      return false;
    } else {
      window.scrollTo({ top: document.documentElement.scrollHeight * 0, behavior: 'instant' });
      return false;
    }
  },
});

export default router;
